import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_location_selector_batchedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { warehouseId: number, locationIds: number[], isExclude: boolean, storageCategoryId?: number, statusId?: number, parentLocationIds?: number[], fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { Name?: string, Id?: number, ParentLocationContainer_Name?: string, Status_Id?: number, Status_Name?: string, TemperatureCategory_Id?: number, TemperatureCategory_LookupCode?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.locationIds)) {
      $missingRequiredInParams.push('\'locationIds\'');
    }
    if (isNil($inParams.isExclude)) {
      $missingRequiredInParams.push('\'isExclude\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { warehouseId?: number, locationIds?: number[], isExclude?: boolean, storageCategoryId?: number, statusId?: number, parentLocationIds?: number[], fullTextSearch?: string, $keys: number[] }): Promise<{ result?: { Name?: string, Id?: number, ParentLocationContainer_Name?: string, Status_Id?: number, Status_Name?: string, TemperatureCategory_Id?: number, TemperatureCategory_LookupCode?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      warehouseId: number, locationIds: number[], isExclude: boolean, storageCategoryId?: number, statusId?: number, parentLocationIds?: number[], fullTextSearch?: string    }) {
        if(isNil($inParams.warehouseId)) {
          return true; 
        }
        if(isNil($inParams.locationIds)) {
          return true; 
        }
        if(isNil($inParams.isExclude)) {
          return true; 
        }
      return false;
    }
}
